import { FormSection } from '../CastingProfile.styles';
import MetadataChipGroup from './MetadataChipGroup';

type BuildFieldProps = {
  options: Array<{ value: string; display: string }>;
  selected: string[];
  onChange: (selected: string[]) => void;
  error?: string;
};

const BuildField = (props: BuildFieldProps) => (
  <FormSection>
    <MetadataChipGroup label="On-brand builds" {...props} />
  </FormSection>
);

export default BuildField;
